module.exports = __webpack_public_path__ + "static/campaign-entrant-861523eb30e01bc01a6ad05ec8486fb6.png";